import React, { PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './Tooltip.module.scss';

export type TooltipProps = {
  icon: JSX.Element;
  className?: string;
};

export const Tooltip = ({ icon, children, className }: PropsWithChildren<TooltipProps>) => {
  return (
    <div className={styles.tooltipWrapper}>
      {icon}
      <div className={cls(styles.tooltip, className)}>{children}</div>
    </div>
  );
};
